import * as React from 'react';
import {UseFormMethods} from 'react-hook-form';
import {TFunction} from 'i18next';

import {FormBuilderFields, FormBuilderFieldType} from '>shared/components/form/formBuilder';
import {Input} from '>shared/components/form/input';

import {isValidEmailAddress} from '>shared/lib/emailValidation';

export function buildForgotPasswordFormFields(
  register: UseFormMethods['register'],
  t: TFunction
): FormBuilderFields {
  const emailRequiredString = t('forgotPassword:form.emailRequiredError');

  function validEmailString(emailToValidate: string): string | undefined {
    const isValid = isValidEmailAddress(emailToValidate);

    return isValid ? undefined : emailRequiredString;
  }

  return [
    {
      type: FormBuilderFieldType.Input,
      name: 'email',
      label: t('forgotPassword:form.emailInputLabel'),
      component: (
        <Input
          autoComplete="email"
          placeholder={t('forgotPassword:form.emailPlaceholder')}
          type="text"
          ref={register({
            required: emailRequiredString,
            validate: validEmailString,
          })}
        />
      ),
    },
  ];
}
